import styled from 'styled-components';
import { SelectOptionsContainer, SelectWrapper } from 'ui/selects';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const QueryBuilderSelectWrapper = styled.div`
  display: flex;

  ${SelectWrapper} {
    border: none;
    box-shadow: none;
  }
`;

export const QueryBuilderSelectWithLinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${spacing.half};
`;

export const StyledSelectOptionsContainer = styled(SelectOptionsContainer)`
  min-width: ${pxToRem(300)};  
  width: 120%;
  max-width: ${pxToRem(672)};
`;

export const ExpandedSelectOptionsContainer = styled(SelectOptionsContainer)`
  width: ${pxToRem(672)}
`;
